import React from "react";
import { cn } from "../../../common/u1/cn";
import { BenefitGrid } from "./BenefitItem";
import { MEMBERSHIP_BENEFITS } from "../../Dashboard/membership/membershipContent";

/* "What you get with membership" — the design's `.mem-benefits`. */
export const MembershipBenefits = ({
  title = "What you get with membership",
  intro = "Five things you get the moment your subscription activates — on either plan.",
  benefits = MEMBERSHIP_BENEFITS,
  tone = "pitch",
  className = "",
}) => (
  <section className={cn("mt-11 border-t border-[var(--line)] pt-8", className)}>
    <h3 className="m-0 mb-1 text-[18px] font-bold text-[var(--ink)] font-sans">{title}</h3>
    {intro && <p className="mt-0 mb-6 text-[14px] text-[var(--muted)] font-sans">{intro}</p>}
    <BenefitGrid benefits={benefits} tone={tone} />
  </section>
);

export default MembershipBenefits;
